export const removeEmptyParams = (object) => {
  const result = {};

  for (let key in object) {
    const value = object[key];

    if (!(value !== 0 && !value)) {
      result[key] = value;
    }

    if (key === "logo") {
      result[key] = value;
    }
  }

  return result;
};
